const SearchableDropdownTypeEnum = {

}
Object.freeze(SearchableDropdownTypeEnum);
export default SearchableDropdownTypeEnum;